<template>

    <div>

        <!--Display the tweet being verified-->
        <h2>Tweet</h2>

        <div id="veracityDisplay" class="p-2 rounded">
            <!--Displays the actual tweet-->
            <Tweet :id="tweet.id_str" :key="tweet.id_str" :options="{conversation: 'none'}">

                <custom-tweet-display :tweet="tweet"></custom-tweet-display>
            </Tweet>

            <div v-if="threadReply">
                <strong>Thread</strong> -
                <a href="#" @click.prevent="showThread = !showThread">
                    <strong>
                        <template v-if="!showThread">show this tweet's thread</template>
                        <template v-else>hide this tweet's thread</template>
                    </strong>
                </a>
                <div :class="['subtweet-container', {'collapse': !showThread}, {'collapse.show': showThread}]">
                    <Tweet  v-for="subReply in threadReply" :id="subReply.id_str" :key="subReply.id_str" :options="{conversation: 'none'}">
                        <custom-tweet-display :tweet="subReply"></custom-tweet-display>
                    </Tweet>
                </div>
            </div>



            <tweet-veracity-help-modal></tweet-veracity-help-modal>

            <!--Tweet veracity box-->
            <transition name="fade">
                <div v-if="!showProvideFeedback" key="veracityDisplay"
                     class="p-2 veracity-display rounded position-relative"
                     style="background: rgba(255, 255, 255, 200)">
                    <h4>Veracity of tweet</h4>
                    <a class="help-btn" data-toggle="modal" data-target="#rumourVeracityHelpModal">
                        <img src="/static/images/help.svg" alt="Explanation of rumour classification"
                             title="Explanation of rumour classification">
                    </a>




                    <!--Feedback option button-->
                    <template v-if="user.isAuthenticated">
                        <input v-if="!showProvideFeedback" id="veracityFeedbackOptin" type="button"
                               class="form-control btn btn-primary" value="Provide feedback"
                               @click="toggleShowFeedback()">
                               </input>
                    </template>
                    <p v-else><a href="/login">Login</a> or <a href="/register">Register</a> to provide feedback.</p>
                    <p />
                </div>

                <!--Provide feedback box-->
                <div v-else key="veracityFeedback" class="p-2 rounded position-relative"
                     style="background: rgba(255, 255, 255, 200)">
                    <h4><img src="/static/images/feedback.svg" alt="Rumour veracity feedback" style="height: 2em;"/>
                        Your
                        feedback</h4>
                    <a class="help-btn" data-toggle="modal" data-target="#rumourVeracityHelpModal">
                        <img src="/static/images/help.svg" alt="Explanation of rumour classification"
                             title="Explanation of rumour classification">
                    </a>
                    <p>
                        You can provide your own feedback to the veracity classification here. Drag the slider to
                        specify the veracity and please provide a reason for your classification.
                    </p>

                    <div class="mb-2">
                        <strong>Please drag slider to provide a veracity rating:</strong>
                    </div>
                    <veracity-slider :veracity="veracityFeedback" :is-enabled="true"
                                     @input="veracityFeedbackChanged"></veracity-slider>


                    <div class="mb-2"><strong>Please provide evidence for the veracity rating:</strong></div>
                    <textarea id="veracityFeedbackEvidenceText" v-model="veracityEvidenceFeedback"
                              name="veracityFeedbackText"
                              class="form-control mb-4"></textarea>
                    <input id="veracityFeedbackSubmit" type="button" class="form-control btn btn-primary mb-2"
                           value="Submit feedback" @click="submitFeedback()"/>
                    <input id="veracityFeedbackCancel" type="button" class="form-control btn btn-danger mb-2"
                           value="Cancel" @click="toggleShowFeedback()"/>
                </div>
            </transition>
            <div id="machineVeracityDisplay" class="p-2 rounded">
            <!--Showing auto veracity - only for English language & if showMachineVeracity==true-->
                <template v-if="tweet.lang == 'en' && siteConfig.showMachineVeracity">
                    <transition name="fade">
                        <button id="showMachineVeracityBtn" class="form-control btn btn-secondary mb-2"
                                @click="toggleVeracity()" v-if="!showVeracity">
                            <img src="/static/images/robot.svg" alt="Show auto-veracity prediction"
                                    title="Show auto-veracity prediction" class="img-fluid"
                                    style="height: 2em; filter: invert(100%)"/>
                            Show machine-generated veracity
                        </button>
                        <div id="machineVeracity" v-else>
                            <div class="row no-gutters">
                                <div class="col-2">
                                    <img src="/static/images/robot.svg" alt="Our algorithm says..."
                                            title="Our algorithm says..." class="img-fluid" style="height: 3em"/>
                                </div>
                                <div class="col-10">
                                    <veracity-slider :veracity="veracity"></veracity-slider>
                                </div>
                            </div>
                        </div>
                    </transition>
                </template>
                <button v-else-if="tweet.lang == 'und'" type="button" class="btn btn-secondary form-control mb-2"
                        title="Machine-generated veracity not available, text not recognised" disabled>
                    <img src="/static/images/robot.svg" alt="Show auto-veracity prediction"
                            title="Show auto-veracity prediction" class="img-fluid"
                            style="height: 2em; filter: invert(100%)"/>
                    Text not recognised
                </button>
                <button v-else-if="!showMachineVeracity" type="button" class="btn btn-secondary form-control mb-2"
                        title="Machine-generated veracity disabled" disabled>
                    <img src="/static/images/robot.svg" alt="Show auto-veracity prediction"
                            title="Show auto-veracity prediction" class="img-fluid"
                            style="height: 2em; filter: invert(100%)"/>
                    Machine-generated veracity disabled
                </button>
                <button v-else type="button" class="btn btn-secondary form-control mb-2"
                        title="Machine-generated veracity not available for this language" disabled>
                    <img src="/static/images/robot.svg" alt="Show auto-veracity prediction"
                            title="Show auto-veracity prediction" class="img-fluid"
                            style="height: 2em; filter: invert(100%)"/>
                    Not available for this language
                </button>
            </div>

            <!-- Other user's veracity responses -->
            <tweet-veracity-responses v-if="siteConfig.showOtherUserVotes"></tweet-veracity-responses>

        </div>


    </div>

</template>

<script>

    import VeracitySlider from "./VeracitySlider";
    import TweetVeracityHelpModal from "./TweetVeracityHelpModal";
    import TweetVeracityResponses from "./TweetVeracityResponses";
    import {mapGetters, mapActions, mapState} from 'vuex';
    import TweetReply from "./TweetReply";
    import CustomTweetDisplay from "./CustomTweetDisplay";

    export default {
        name: "TweetVeracityDisplay",
        props: ["tweet", "user"],
        data: function () {
            return {
                showVeracity: false,
                showProvideFeedback: true,
                veracity: 0,
                veracityFeedback: 0,
                veracityEvidenceFeedback: "",
                showThread: false
            }
        },
        computed:{
          ...mapGetters(["threadReply"]),
          ...mapState(["siteConfig"])
        },
        methods: {
            ...mapActions(["addVeracityVote"]),
            toggleVeracity() {
                this.showVeracity = !this.showVeracity;
            },
            toggleShowFeedback() {
                this.showProvideFeedback = !this.showProvideFeedback;
            },
            veracityFeedbackChanged(newVeracity) {
                this.veracityFeedback = newVeracity;
            },
            submitFeedback() {
                this.addVeracityVote({
                    tweetId: this.tweet.id_str,
                    veracity: this.veracityFeedback,
                    evidence: this.veracityEvidenceFeedback,
                });
                this.showProvideFeedback = false;
            }
        },
        watch: {
            tweet: {

                handler(newTweet, oldTweet) {
                    this.veracity = newTweet.veracity;

                }

            }
        },
        components: {
            TweetReply,
            TweetVeracityResponses,
            TweetVeracityHelpModal,
            VeracitySlider,
            CustomTweetDisplay,
        },
    }
</script>

<style scoped>


</style>
